import { useForm } from 'react-hook-form';
import {
  Button,
  Center,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Select,
  useToast,
  VStack,
} from '@chakra-ui/react';

import {
  useCreateFeature,
  useCreateProduct,
} from '@/modules/common/commonHooks';
import { errorHandler } from '@/shared/errorHandler';

type FormValues = {
  type: string;
  name: string;
};

function CreateFeatureOrProductContainer() {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<FormValues>();

  const { mutate: mutateFeature, isLoading: featureLoading } =
    useCreateFeature();
  const { mutate: mutateProduct, isLoading: productLoading } =
    useCreateProduct();
  const toast = useToast();

  const onSubmit = async (data: FormValues) => {
    if (data.type === 'feature') {
      mutateFeature(
        { featiureName: data.name },
        {
          onSuccess: () => {
            toast({
              title: 'Feature created',
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
          },
          onError: (error) => {
            toast({
              title: 'Something went wrong',
              status: 'error',
              description: errorHandler(error),
            });
          },
        },
      );
    } else {
      mutateProduct(
        { productName: data.name },
        {
          onSuccess: () => {
            toast({
              title: 'Product created',
              status: 'success',
              duration: 3000,
              isClosable: true,
            });
          },
          onError: (error) => {
            toast({
              title: 'Something went wrong',
              status: 'error',
              description: errorHandler(error),
            });
          },
        },
      );
    }
  };

  return (
    <Center>
      <VStack textAlign={'center'}>
        <Heading>Create new product or feature</Heading>
        <form onSubmit={handleSubmit(onSubmit)}>
          <VStack>
            <FormControl isInvalid={!!errors.type}>
              <FormLabel htmlFor="selectType">Select Type</FormLabel>
              <Select
                {...register('type', {
                  required: 'This is required',
                })}
                placeholder="Select Type"
              >
                <option value="product">Product</option>
                <option value="feature">Feature</option>
              </Select>
              <FormErrorMessage>
                {errors.type && errors.type.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={!!errors.name}>
              <FormLabel htmlFor="selectType">Name</FormLabel>
              <Input
                {...register('name', {
                  required: 'This is required',
                })}
              />
              <FormErrorMessage>
                {errors.name && errors.name.message}
              </FormErrorMessage>
            </FormControl>
            <Button isLoading={featureLoading || productLoading} type="submit">
              Submit
            </Button>
          </VStack>
        </form>
      </VStack>
    </Center>
  );
}

export { CreateFeatureOrProductContainer };
